<div class="tw-relative tw-w-full tw-h-full tw-overflow-hidden tw-rounded-2">
  <canvas #c class="tw-absolute tw-inset-0 tw-h-full tw-w-full"></canvas>
  @if (loading()) {
    <div class="tw-absolute tw-inset-0 tw-bg-gray-200 tw-animate-pulse"></div>
  }
</div>
